export default __webpack_public_path__ + "static/media/img8.ddcc7ae3.jpg";